// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({standalone: true, selector: '[capsLock]'})
export class TrackCapsDirective {
  @Output() capsLock = new EventEmitter<boolean>();

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
      this.capsLock.emit(event.getModifierState && event.getModifierState('CapsLock'));
  }
  @HostListener('window:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent): void {
      this.capsLock.emit(event.getModifierState && event.getModifierState('CapsLock'));
  }
}
